import { render, staticRenderFns } from "./Beijing.vue?vue&type=template&id=acc41c3c&scoped=true"
import script from "./Beijing.vue?vue&type=script&lang=js"
export * from "./Beijing.vue?vue&type=script&lang=js"
import style0 from "./Beijing.vue?vue&type=style&index=0&id=acc41c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc41c3c",
  null
  
)

export default component.exports